module.exports = __webpack_public_path__ + "img/bgaming.7d6257a3.svg";